import type { IScreenShareChatMessage, IScreenShareChatState } from '@srm/screen-sharing/light';

export { CHAT_TEXT_LIMIT as SUPPORT_CHAT_LIMIT } from '@srm/screen-sharing/light';
/** Кнопка «Чат» полосы показа: свёрнутая панель возвращает на неё фокус. */
export const SUPPORT_CHAT_TOGGLE_ATTRIBUTE = 'data-support-chat-toggle';
/** Чат не принял сообщение: показ ещё не начался на сервере (или уже кончился) — текст остаётся в поле. */
export const SUPPORT_CHAT_NOT_READY_TEXT = 'Чат заработает, когда показ начнётся';
/** Кнопка «Микрофон» полосы показа: к ней — хвостик подсказки и фокус после «Включить микрофон» в карточке. */
export const SUPPORT_MIC_TOGGLE_ATTRIBUTE = 'data-support-mic-toggle';

/** Сообщение чата показа (IMPLEMENTATION.md §30, «Отклонения этапа 5 потока P5»). */
export type ISupportChatMessage = IScreenShareChatMessage;
export type ISupportChatState = IScreenShareChatState;

export const emptySupportChat: ISupportChatState = {
    messages: [],
    typing: [],
    unread: 0,
    lastReadId: null,
    readBy: {},
    quickReplies: [],
};

/** Последнее своё сообщение, которое прочитал кто-то из специалистов: у него в чате — «прочитано». */
export function lastReadOwnKey(chat: Pick<ISupportChatState, 'messages' | 'readBy'>): string | null {
    const marks = Object.values(chat.readBy);
    if (!marks.length) return null;
    const read = Math.max(...marks);
    const own = chat.messages.filter((message) => message.mine && message.id !== undefined && message.id <= read);
    return own.at(-1)?.key ?? null;
}
